import gsap from 'gsap'

import Site from 'stores/Site'

export default class Faq {
    constructor(el) {
        const faqs = el.querySelectorAll('.faq')

        faqs.forEach(faq => {
            const header = faq.querySelector('.faq-question')
            const body = faq.querySelector('.faq-answer')

            header.addEventListener('click', () => {
                if (faq.classList.contains('active')) {
                    gsap.to(body, {
                        height: 0,
                        clipPath: 'inset(0% 0% 100% 0%)',
                        duration: .3,
                        immediateRender: false,
                        ease: 'Power3.easeOut',
                    })

                    faq.classList.remove('active')
                } else {
                    gsap.to(body, {
                        height: 'auto',
                        clipPath: 'inset(0% 0% 0% 0%)',
                        duration: .4,
                        immediateRender: false,
                        ease: 'Power3.easeOut',
                    })

                    faq.classList.add('active')
                }
            })
        })
    }
}